import React from "react";
import styled, { withTheme } from "styled-components/native";
import StoredRoundImage from "./StoredRoundImage";

/* Because of a RN bug, we have to separate the shadow from the overflow: hidden, as per: https://github.com/facebook/react-native/issues/449 */
const Shadow = styled.View`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: ${props => props.size / 2}px;
  box-shadow: ${props => props.theme.avatarShadow};
`;

/**
 * Displays a user's avatar (stored in Amazon S3 for example) using the image resizer service.
 *
 * In cases where the imageId is not specified, a placeholder is used instead.
 *
 * Props:
 * imageId: Token id of the image as found in the Amazon S3 bucket, this is used by the image resizer.
 * size: Width and height of the image as it will be shown.
 * placeholder: Image that will be used when the imageId is null.
 * templateIndex: Template index configured in the image resizer on the server side.
 */
const Avatar = props => (
  <Shadow size={props.size}>
    <StoredRoundImage
      {...props}
      placeholder={require("../assets/images/placeholder.png")}
    />
  </Shadow>
);

export default withTheme(Avatar);
